import { cx } from "classix"
import { type CSSProperties, memo } from "react"
import { useMediaQuery } from "react-responsive"

import { Href, IconButtonProps } from "~/shared/ui"
import { breakPoints } from "~/shared/ui/constants"
import { ReloadButton } from "~/shared/ui/layouts/main/ReloadButton"

import cssModule from "./index.module.scss"
import { MenuButton } from "~/shared/ui/layouts/main/MenuButton"
import { LogoCurtain } from "~/shared/ui/layouts/main/LogoCurtain"


export type LogoProps = {
	onClick?: () => void,
	enableTransition: boolean,
	logoUrl: string
	logoText: string
	hideCurtain: boolean
	showMenuButton: boolean
	onMenuButtonClick?: () => void
	customization?: {
		style?: CSSProperties
		className?: string
		closeMenuButton?: {
			colorStyle?: IconButtonProps["colorStyle"]
			style?: CSSProperties
			className?: string
		}
		curtain?: {
			style?: CSSProperties
			className?: string
		}
	}
}

export const Logo = memo(function Logo({
										   logoUrl,
										   logoText,
										   hideCurtain,
										   showMenuButton,
										   onMenuButtonClick,
										   customization = {},
										   enableTransition,
										   onClick
									   }: LogoProps) {

	const showReloadButton = useMediaQuery({ maxWidth: breakPoints.xs })

	return (
		<>
			<div
				style={customization.style}
				className={cx(cssModule.logo, enableTransition && cssModule.transition, customization.className)}>
				{showMenuButton &&
					<MenuButton hideCurtain={hideCurtain} closeMenuButton={customization.closeMenuButton}
								onClick={onMenuButtonClick} />
				}
				<Href href={logoUrl} onClick={onClick}>
					<h1>{logoText}</h1>
				</Href>
				{showReloadButton && <ReloadButton style={{ position: "absolute", right: "1.25rem" }} />}
			</div>
			<LogoCurtain style={customization?.curtain?.style}
						 className={customization.curtain?.className}
						 hideCurtain={hideCurtain}
						 href={logoUrl}
						 logoText={logoText}
						 onClick={onClick}
						 enableTransition={enableTransition}
			/>

		</>
	)
})
